import React from 'react';
import FaceImage from "./FaceImage";
import ShadowButton from './ShadowButton';

export default function About() {
  // Force scrollbar to always be visible
  React.useEffect(() => {
    document.documentElement.style.overflowY = 'scroll';
    return () => {
      document.documentElement.style.overflowY = 'auto';
    };
  }, []);

  return (
    <div className="mt-8 md:mt-12">
      {/* Hero Section */}
      <div className="max-w-5xl mx-auto px-4 mb-16 opacity-0 animate-fade-in-up animation-delay-200 relative">
        <div className="flex flex-col md:flex-row md:justify-between md:items-center mt-8 gap-8">
          {/* Mobile centered profile image */}
          <div className="flex justify-center mb-8 md:hidden">
            <FaceImage />
          </div>
          
          <div className="md:w-2/3">
            <h1 className="text-4xl md:text-5xl font-bold md:mb-4">I like building cool stuff with fun people</h1>
          </div>
          
          {/* Profile image - normal positioning on desktop */}
          <div className="md:w-1/3 hidden md:block">
            <FaceImage />
          </div>
        </div>
      </div>

{/* Intro Section */}
<div className="max-w-5xl mx-auto px-4 my-16">
  <p className="text-base md:text-lg text-gray-700 mb-8">I'm Christophe, a venture builder based in Belgium. I validate and ship new products for companies entering new markets or testing business models.</p>
  
  <p className="text-base md:text-lg text-gray-700 mb-8">
Since 2008, I've worked across strategy, UX, product, and go-to-market. I focus on moving fast from concept to proven traction before committing to full-scale builds.
  </p>
  
  <p className="text-base md:text-lg text-gray-700 mb-8">
    Ready to build something impactful together? Let's connect 👇
  </p>
</div>


<div className="max-w-5xl mx-auto px-4">
  <div className="my-24 bg-gray-100 p-12 rounded-lg mb-24">
    <h2 className="text-2xl text-center font-bold mb-6">Let's connect</h2>
    <p className="text-center mb-8 max-w-lg mx-auto">Please don't hesitate to reach out if you want to chat about work, side projects, share feedback, or just connect.</p>
    <div className="flex flex-col sm:flex-row gap-3 justify-center">
      <ShadowButton href="mailto:christophe@vaneerdt.be" fullWidth>
        Email me
      </ShadowButton>
      <ShadowButton href="tel:+32479706342" fullWidth>
        Call me
      </ShadowButton>
      <ShadowButton href="https://www.linkedin.com/in/cvaneerdt/" fullWidth>
        LinkedIn
      </ShadowButton>
    </div>
  </div>
</div>

    </div>
  );
}